import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BibimbapView from '../views/BibimbapView.vue'
import BulgogiView from '../views/BulgogiView.vue'
import KimbapView from '../views/KimbapView.vue'
import TempuraView from '../views/TempuraView.vue'
import DumplingView from '../views/DumplingView.vue'
import FriedRiceView from '../views/FriedRiceView.vue'
import ComboView from '../views/ComboView.vue'
import NoodleView from '../views/NoodleView.vue'
import JjigaeView from '../views/JjigaeView.vue'
import SoupView from '../views/SoupView.vue'
import SpicyBowlsView from '../views/SpicyBowlsView.vue'
import SideDishView from '../views/SideDishView.vue'
import SmallPlatesView from '../views/SmallPlatesView.vue'
import JapchaeTteokbokkiView from '../views/JapchaeTteokbokkiView.vue'
import KoreanPancakeView from '../views/KoreanPancakeView.vue'
import DrinksView from '../views/DrinksView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  {
    path: '/Bibimbap',
    name: 'Bibimbap',
    component: BibimbapView
  },

  {
    path: '/Bulgogi',
    name: 'Bulgogi',
    component: BulgogiView
  },

  {
    path: '/Kimbap',
    name: 'Kimbap',
    component: KimbapView
  },

  {
    path: '/Tempura',
    name: 'Tempura',
    component: TempuraView
  },

  {
    path: '/Dumpling',
    name: 'Dumpling',
    component: DumplingView
  },

  {
    path: '/FriedRice',
    name: 'FriedRice',
    component: FriedRiceView
  },

  {
    path: '/Combo',
    name: 'Combo',
    component: ComboView
  },

  {
    path: '/Noodle',
    name: 'Noodle',
    component: NoodleView
  },

  {
    path: '/Jjigae',
    name: 'Jjigae',
    component: JjigaeView
  },

  {
    path: '/Soup',
    name: 'Soup',
    component: SoupView
  },

  {
    path: '/SpicyBowls',
    name: 'SpicyBowls',
    component: SpicyBowlsView
  },

  {
    path: '/SideDish',
    name: 'SideDish',
    component: SideDishView
  },

  {
    path: '/SmallPlates',
    name: 'SmallPlates',
    component: SmallPlatesView
  },

  {
    path: '/JapchaeTteokbokki',
    name: 'JapchaeTteokbokki',
    component: JapchaeTteokbokkiView
  },

  {
    path: '/KoreanPancake',
    name: 'KoreanPancake',
    component: KoreanPancakeView
  },

  {
    path: '/Drinks',
    name: 'Drinks',
    component: DrinksView
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
